/*!
 * mime-db
 * Copyright(c) 2014 Jonathan Ong
 * MIT Licensed
 */

/**
 * Module exports.
 */

module.exports = require('./db.json')



//////////////////
// WEBPACK FOOTER
// ./~/mime-db/index.js
// module id = 291
// module chunks = 0